import { Modal } from '../components/modal';
import { useEffect } from 'react';
import { playWinningSound } from '../utils/audio';

export const WinDisplay = ({ amount, multiplier , open, onClose }) => {


    useEffect(() => {
      if (open) {
        playWinningSound();
        setTimeout(() => {
          onClose();
        }, 1500);
      }
    }, [open]);
    
    return open ? (<Modal open={open} onClose={onClose}>
    <div style={{
      textAlign: 'center',
      padding: '40px 20px',
      //background: 'linear-gradient(135deg, #1a4d2e 0%, #2d5f3f 100%)',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
      position: "fixed",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -60%)",
      zIndex: 100000,
      background: "#18181b",
      padding: "24px 20px",
      borderRadius: "15px",
      maxWidth: 540,
      minWidth: 310,
      width: "90vw",
      margin: "0",
      boxShadow: "0 0 24px #0007",
    }}>
      <div style={{
        fontSize: '1.2rem',
        color: '#a8e6a1',
        marginBottom: '16px',
        fontWeight: '600',
        letterSpacing: '2px',
        textTransform: 'uppercase'
      }}>
        You Win!
      </div>
      <div style={{
        fontSize: '3rem',
        color: '#fff',
        fontWeight: 'bold',
        marginBottom: '24px',
        textShadow: '0 2px 8px rgba(0, 0, 0, 0.4)'
      }}>
        {amount.toFixed(2)} Br
      </div>
      <div style={{
        fontSize: '0.9rem',
        color: '#c5e8c0',
        marginBottom: '8px',
        opacity: 0.8
      }}>
        Multiplier
      </div>
      <div style={{
        fontSize: '2rem',
        color: '#ffd700',
        fontWeight: 'bold',
        textShadow: '0 2px 8px rgba(255, 215, 0, 0.3)'
      }}>
        {multiplier.toFixed(2)}x
      </div>
    </div>
    </Modal>
    ) : null;
  };


  export const NotEnoughBalanceModal = ({ open, onClose }) => {
    return open ? (
      <Modal open={open} onClose={onClose}>
        <div style={{
          position: "fixed",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -60%)",
          zIndex: 100000,
        }} onClick={onClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{
            background: "#18181b",
            padding: "24px 20px",
            borderRadius: "15px",
            maxWidth: 540,
            minWidth: 310,
            width: "90vw",
            margin: "0",
            boxShadow: "0 0 24px #0007",
            textAlign: "center",
           
          }}>
            <div style={{
              fontSize: '1.2rem',
              color: '#ff6b6b',
              marginBottom: '16px',
              fontWeight: '600',
              letterSpacing: '2px',
              textTransform: 'uppercase'
            }}>
              Not Enough Balance
            </div>
            <div style={{
              fontSize: '1rem',
              color: '#ccc',
              marginBottom: '24px'
            }}>
              You don't have enough balance to place this bet.
            </div>
            <button
              onClick={onClose}
              style={{
                background: '#ff6b6b',
                color: '#fff',
                border: 'none',
                padding: '12px 32px',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              OK
            </button>
          </div>
        </div>
      </Modal>
    ) : null;
  };